import axios from "axios";
import { Domain_URL } from "../constants/states";
import { getUserDetail, isValidJson } from "./helper";
const axiosConfig = {
  baseURL: Domain_URL + "api/",
  timeout: 300000,
};
const instance = axios.create(axiosConfig);
// Request interceptor for API calls
instance.interceptors.request.use(
  async (config) => {
    config.params = {
      token: getUserDetail()?.token,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Response interceptor for API calls
instance.interceptors.response.use(
  (response) => {
    if (response.data !== "") {
      if (isValidJson(response.data)) {
        if (response.data?.isNotAuthorized) {
          localStorage.removeItem("userDetail");
          localStorage.removeItem("practitionerForAdmin");
          localStorage.removeItem("adminDetail");
          window.location.href = "/login";
        } else {
          return response;
        }
      } else {
        return Promise.reject();
      }
    } else {
      return response;
    }
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      axios.defaults.config.params = { token: getUserDetail()?.token };
      return instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default instance;
